import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {NutshellLogoMarkIcon} from '../icon/svg/nutshell-logo-mark-icon';
import {Illustration} from '../illustrations/illustration';
import {Stack} from '../layout/stack/stack';
import {Link} from '../link/link';
import {ProgressBar} from '../progress-bar/progress-bar';
import {Body} from '../typography/body';

import {TrialGatheringPillCarousel} from './trial-gathering-pill-carousel';
import {TrialGatheringPrompt} from './trial-gathering-prompt';

import styles from './trial-gathering-preparing.module.css';

type Props = {
    pills: string[];
    progress: number;
    errorProvisioning: boolean;
};

export function TrialGatheringPreparing(props: Props) {
    return (
        <div className={styles.container}>
            {!props.errorProvisioning && (
                <div className={styles['progress-bar-container']}>
                    <ProgressBar height={8} color={colors.blue} percentComplete={props.progress} />
                </div>
            )}
            <div className={styles.content}>
                <Stack spacing={36} alignItems='center'>
                    <NutshellLogoMarkIcon fill={colors.orange} size={45} />
                    {props.errorProvisioning ? (
                        <>
                            <TrialGatheringPrompt>
                                Something went wrong
                                <br />
                                setting up your Nutshell account.
                            </TrialGatheringPrompt>
                            <Body size='large'>
                                This shouldn’t happen! Please contact our support team at <br />
                                <Link
                                    href='mailto:support@nutshell.com'
                                    variant='primary'
                                    size='big'
                                >
                                    support@nutshell.com
                                </Link>
                                .
                            </Body>
                        </>
                    ) : (
                        <>
                            <div className='mb-16'>
                                <TrialGatheringPrompt>
                                    Hang tight!
                                    <br />
                                    We are preparing your dream workspace
                                </TrialGatheringPrompt>
                            </div>
                            <TrialGatheringPillCarousel pills={props.pills} />
                        </>
                    )}
                </Stack>
            </div>
            <div className={classnames('pos-absolute bottom-0 left-0 right-0', styles.scenery)}>
                <Illustration src='trial-onboarding/trial-onboarding-scenery' />
            </div>
        </div>
    );
}
